import React, { memo } from 'react';
import { useTranslate } from 'react-polyglot';
import ActionButtons from '../actionsDialog/ActionButtons';

const DeleteCampaign = memo(function DeleteCampaign(props) {
    const t = useTranslate();
    return (
        <div className='coa-dialog-form coa-dialog-with-action-buttons'>
            <p className='coa-dialog-msg'>{t('pages.campaigns.modal.delete.msg')}</p>
            <p className='coa-dialog-msg-body'>{t('pages.campaigns.modal.delete.msgBody')}</p>
            <ActionButtons
                cancelText={t('actions.cancel')}
                acceptText={t('actions.delete')}
                acceptVariant="danger"
                onClickCancel={(e) => {
                    e.preventDefault();
                    props.setOpen(false);
                }}
                onClickAccept={
                    props.data.removeProjectAndExperiences
                }
            ></ActionButtons>
        </div>
    )
})


export default DeleteCampaign
